// extracted by mini-css-extract-plugin
export default {"search-box":"Z_gM","search-box__input":"Z_gN form-control","search-box__icon":"Z_gP ml-2"};